export default __webpack_public_path__ + "static/media/middle1.d17ecf56.svg";